import i18next from 'i18next'
import languageDetector from 'i18next-browser-languagedetector'

import * as en from './en'
import * as hu from './hu'

export const defaultNS = 'instructions'


export const i18nextMsql = i18next.createInstance()

i18nextMsql
  .use(languageDetector)
  .init({
    supportedLngs: ['en', 'hu'],
    debug: false,
    resources: {en, hu},
    defaultNS,
    fallbackLng: 'en',
    ns: ['instructions', 'questions', 'scales', 'legal'],
    interpolation: {
      escapeValue: false
    }
  })
